import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";
import apiClient from '../api/client';

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      toast.error("Fyll i användarnamn och lösenord.");
      return;
    }
    setLoading(true);
    try {
      const res = await apiClient.post('/admin/login', { username, password });
      localStorage.setItem("admin_token", res.data.token);
      toast.success("Inloggad!");
      navigate("/admin/dashboard");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(detail || "Inloggningen misslyckades.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <Lock className="h-12 w-12 mx-auto text-primary mb-4" />
          <CardTitle className="text-2xl">Klart Hemma Admin</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-4">
            <Input
              placeholder="Användarnamn"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
            />
            <Input
              type="password"
              placeholder="Lösenord"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? <><Loader2 className="animate-spin mr-2 h-4 w-4" /> Loggar in...</> : 'Logga in'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
